"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.agent.speaking': 'Agent is speaking',
    'conversation.agent.thinking': 'Agent is thinking...',
    'conversation.agent.demo': 'Voice Agent Demo',
    'conversation.agent.demo.description': 'Interactive voice conversation with AI agents using advanced speech recognition and synthesis',
};
